import { useQueryClient } from '@tanstack/react-query'

import { CommentProps, Comments } from '@/components'

import { isSuperUser } from '@/helpers'
import {
  QUERIES_ADMIN,
  useOrderCenterCommentRemove,
  useOrderCenterCommentsCreate,
  useOrderCenterCommentsEdit,
  useOrderCenterCommentsList,
} from '@/services'

import { useAuth } from '@/providers'
import { SaleOrderCommentTypesEnum } from '@/types'

import { TabCommentsProps } from './tab-comments.type'

export const TabComments = ({ saleOrderUuid, isLoading }: TabCommentsProps) => {
  const queryClient = useQueryClient()

  const { data, isLoading: isLoadingComments } = useOrderCenterCommentsList(
    saleOrderUuid,
    { ordering: '-createdAt' },
    !!saleOrderUuid,
  )

  const { mutateAsync, isPending } = useOrderCenterCommentsCreate(saleOrderUuid)

  const createComment = async (data: { comment: string }) => {
    return mutateAsync({ ...data, type: SaleOrderCommentTypesEnum.default })
  }

  const { mutateAsync: deleteComment } = useOrderCenterCommentRemove(
    saleOrderUuid || '',
  )
  const { mutateAsync: updateComment } = useOrderCenterCommentsEdit(
    saleOrderUuid || '',
  )

  const { whoAmI } = useAuth()

  const hasPermissionToEditOrDelete = (
    item: CommentProps<SaleOrderCommentTypesEnum>,
  ) =>
    (whoAmI?.email === item?.user?.email || isSuperUser(whoAmI?.email)) &&
    item?.type === SaleOrderCommentTypesEnum.default

  const isLoadingAll = isLoading || isLoadingComments || isPending

  return (
    <>
      <Comments<SaleOrderCommentTypesEnum>
        comments={data?.data?.results}
        createComment={createComment}
        deleteComment={deleteComment}
        updateComment={updateComment}
        hasPermissionToEditOrDelete={hasPermissionToEditOrDelete}
        isLoading={isLoadingAll}
        invalidateQueries={() =>
          queryClient.invalidateQueries({
            queryKey: [QUERIES_ADMIN.ORDER_CENTER_COMMENTS.module],
          })
        }
      />
    </>
  )
}
